<template>
  <div class="FactoryTour">
    <header class="entry-header">
      <div class="cv-container">
        <h1 class="entry-title">Factory Tour</h1>
      </div>
    </header>

    <div class="container">
      <div class="stats">
        <div class="stat-item">
          <div class="stat-number">50,000㎡</div>
          <div class="stat-text">工厂面积</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">300+</div>
          <div class="stat-text">技术员工</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">98%</div>
          <div class="stat-text">良品率</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">24/7</div>
          <div class="stat-text">持续生产</div>
        </div>
      </div>

      <div class="intro">
        <h2>欢迎参观我们的智能工厂</h2>
        <p>
          我们的工厂采用最先进的智能制造技术，实现了生产过程的自动化、信息化和智能化。通过数字化管理系统，我们能够实时监控生产状态，优化生产流程，确保产品质量的同时提高生产效率。
        </p>
        <p>
          工厂总面积达5万平方米，拥有10条自动化生产线，年产能超过100万台设备。我们的产品远销全球30多个国家和地区，深受客户好评。
        </p>

        <div class="features">
          <div class="feature">
            <i class="fas fa-cogs"></i>
            <h3>自动化生产</h3>
            <p>采用机器人自动化生产线，提高生产效率</p>
          </div>
          <div class="feature">
            <i class="fas fa-leaf"></i>
            <h3>绿色制造</h3>
            <p>贯彻环保理念，实现清洁生产和资源循环利用</p>
          </div>
          <div class="feature">
            <i class="fas fa-microchip"></i>
            <h3>智能检测</h3>
            <p>利用AI视觉技术进行产品质量自动检测</p>
          </div>
        </div>
      </div>

      <h2 style="text-align: center; margin-bottom: 30px; color: #b71c1c">
        工厂实景展示
      </h2>

      <div class="gallery">
        <div
          class="gallery-item"
          data-index="0"
          v-for="(item, index) in 12"
          :key="index"
        >
          <img :src="getImgPath(index)" alt="" />
          <div class="gallery-caption">查看大图</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FactoryTour',
  components: {},
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    getImgPath (index) {
      index += 1
      return require('@/assets/aa-' + index + '.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  max-width: 1350px;
  margin: 0 auto;
  padding: 20px;
}
/* 图片网格布局 */
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.gallery-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 220px;
  border: 3px solid transparent;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(183, 28, 28, 0.25);
  border-color: #d32f2f;
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.gallery-item:hover img {
  transform: scale(1.05);
}

.gallery-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(183, 28, 28, 0.85);
  color: white;
  padding: 12px;
  font-size: 0.9rem;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-caption {
  transform: translateY(0);
}

/* 工厂介绍部分 */
.intro {
  background-color: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  margin-bottom: 40px;
  border-left: 5px solid #d32f2f;
}

.intro h2 {
  color: #b71c1c;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ff5252;
}

.intro p {
  margin-bottom: 15px;
  line-height: 1.8;
  color: #555;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.feature {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: transform 0.3s ease;
  border-top: 3px solid #d32f2f;
}

.feature:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(183, 28, 28, 0.15);
}

.feature i {
  font-size: 2.5rem;
  color: #d32f2f;
  margin-bottom: 15px;
}

.feature h3 {
  color: #b71c1c;
  margin-bottom: 10px;
}

/* 数据统计 */
.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin: 40px 0;
}

.stat-item {
  text-align: center;
  padding: 30px 20px;
  background: linear-gradient(to bottom right, #b71c1c, #d32f2f);
  color: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(183, 28, 28, 0.3);
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.stat-text {
  font-size: 1.1rem;
}

footer {
  text-align: center;
  margin-top: 60px;
  color: #777;
  font-size: 0.9rem;
  padding: 20px;
  background: #b71c1c;
  color: white;
  border-radius: 10px 10px 0 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .gallery {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  h1 {
    font-size: 2.2rem;
  }

  .intro {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutus/FactoryTour.vue